import React from 'react';
import { connect } from 'react-redux';

// Components
import { setTextSize, setTextBold, setTextItalic, setTextUnderline, setTextColour } from 'components/collage/CollageSlice.js';
import ColourPicker from 'components/misc/colour_picker/ColourPicker.js';
import NumericInput from 'react-numeric-input';

// CSS
import './EditBar.css';

class EditBar extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      colourPickerOpen: false
    }
  }

  handleFontSizeChange = (num) => {
    if ( parseInt(num) > 0 ) {
      this.props.setTextSize(num);
      // this.setState({
      //   fontSize: event.target.value
      // });
    }
  }

  render() {

    // let className = 'IconOption ButtonReset' + (this.props.highlight ? ' IconOption--Highlight' : '');
    let className   = 'EditBar';
    let textConfig  = this.props.collage.texts[this.props.collage.activeText];

    return (
      <div 
        id="EditBar"
        className={className}
      >
        <span className={'TextTitle'}>Text Options</span>

        <div className="TextColour">
          <button 
            className="ButtonReset CurrentColor"
            onClick={() => this.setState({colourPickerOpen: !this.state.colourPickerOpen})}
            style={{
              backgroundColor: textConfig.color
            }}
          >
            <span class="sr-only">Change Background Colour</span>
          </button>
          {this.state.colourPickerOpen &&
            <div className="TextColourPicker">
              <ColourPicker 
                colour={textConfig.color}
                onExit={() => this.setState({colourPickerOpen: false})}
                onPickColour={(colour) => {this.props.setTextColour(colour)}}
              />
            </div>
          }
        </div>

        <NumericInput
          min={0}
          max={200}
          value={textConfig.fontSize} 
          onChange={this.handleFontSizeChange}
          mobile={this.props.collage.mode == 'sm'}
          format={(num) => {
            return num + ' px';
          }}
        />

        <div className="TextStyles">
          <button 
            className={'ButtonReset TextStyles--Bold' + (textConfig.fontWeight == 700 ? ' TextStyles--Active' : '')} 
            title="Make text bold"
            onClick={this.props.setTextBold}
          >
            <span aria-hidden="true">B</span>
            <span className="sr-only">Bold</span>
          </button>
          <button 
            className={'ButtonReset TextStyles--Italic' + (textConfig.fontStyle == 'italic' ? ' TextStyles--Active' : '')}
            title="Make text italic"
            onClick={this.props.setTextItalic}
          >
            <span aria-hidden="true">I</span>
            <span className="sr-only">Italic</span>
          </button>
          <button 
            className={'ButtonReset TextStyles--Underline' + (textConfig.textDecoration == 'underline' ? ' TextStyles--Active' : '')} 
            title="Make text have underline"
            onClick={this.props.setTextUnderline}
          >
            <span aria-hidden="true">U</span>
            <span className="sr-only">Underline</span>
          </button>
        </div>

      </div>
    );
  }
}

const mapStateToProps = state => ({
  collage: state.collage
});

export default connect(
  mapStateToProps,
  {setTextSize, setTextBold, setTextItalic, setTextUnderline, setTextColour}
)(EditBar)
